import { Injectable } from '@angular/core';

import { UtilsService } from '../services/utils.service';

@Injectable()
export class LegendOptionsService {

    constructor(
        private readonly utilsService: UtilsService
    ) { }

    optionsAttached(event: CustomEvent<{ target: HTMLElement, layerId: string }>) {
        let compScope = this;
        event.detail.target.getElementsByClassName('layer-options-button')[0].addEventListener('click', function (event) { compScope.dropdownToggle(this, event as MouseEvent); });

        const esriLayer = this.utilsService.esriMap.findLayerById(event.detail.layerId);
        let removeClasses;
        switch (esriLayer.type) {
            case 'graphics':
                removeClasses = ['buffer-layer-option', 'copy-option', 'data-table-option', 'export-shapefile-option',
                    'export-excel-option', 'filter-option', 'labels-option',
                    'spatial-query-option', 'theme-editor-option', 'details'];
                break;
            case 'feature':
                removeClasses = ['buffer-layer-option', 'copy-option', 'data-table-option', 'export-shapefile-option',
                    'export-excel-option', 'filter-option', 'labels-option',
                    'spatial-query-option', 'theme-editor-option'];
                break;
            case 'map-image':
                removeClasses = ['remove-all'];
        }
        if (removeClasses) {
            for (const cls of removeClasses) {
                const els = event.detail.target.getElementsByClassName(cls);
                if (els && els.length) {
                    Array.from(els).forEach(el => el.remove());
                }
            }
        }
    }

    dropdownToggle(target: HTMLElement, event: MouseEvent, forceClose?: boolean) {
        let drop = target.parentElement.getElementsByClassName('dropdown-menu')[0] as HTMLElement;
        if (drop) {
            let currentDisplay = drop.style.display;
            drop.style.display = currentDisplay === 'block' || forceClose ? '' : 'block';
            drop.style.bottom = this.shouldDropUp(drop) ? '25px' : null;
        }
        const restClickListener = (e: MouseEvent) => {
            if (!(e.target as HTMLElement).classList.contains('dropdown-link')) {
                this.dropdownToggle(target, e, true);
                window.removeEventListener('click', restClickListener);
            }
        };
        event.stopPropagation();
        if (drop.style.display === 'block') {
            window.addEventListener('click', restClickListener);
        } else {
            window.removeEventListener('click', restClickListener);
        }
    }

    shouldDropUp(drop: HTMLElement) {
        let parent = drop.offsetParent as HTMLElement;
        let i = 0;
        while ((!parent || !parent.classList.contains('side-nav')) && i < 5) {
            i++;
            if (parent) {
                parent = parent.offsetParent as HTMLElement;
            } else {
                break;
            }
        }
        let retVal = false;
        if (parent) {
            parent = parent.getElementsByClassName('legend-area')[0] as HTMLElement;
            let dropRect = drop.getBoundingClientRect();
            let parentRect = parent.getBoundingClientRect();
            const dropRectTop = dropRect.top - parentRect.top;
            if (dropRectTop > dropRect.height && dropRect.bottom > parentRect.height) {
                retVal = true;
            }
        }
        return retVal;
    }

}